import { BaseModel } from "@/models/BaseModel";
import { Questionnaire } from "@/models/Questionnaire";
import { User } from "@/models/User";

export class CompanyQuestionnaire extends BaseModel {
  constructor({ id = null, questionnaire, is_active, receivers = [] }) {
    super();

    this.id = id;
    this.questionnaire = questionnaire ? new Questionnaire(questionnaire) : null;
    this.is_active = is_active;
    this.receivers = receivers.map((r) => new User(r));
  }
}

export default CompanyQuestionnaire;
